import { connect } from "react-redux";

export function mapStateToProps(state) {
    const {
        loginRegister = {}
    } = state;

    return {
        email: loginRegister.email
    };
}

function emailResentContainer(component) {
    return connect(
        mapStateToProps
    )(component);
}

export default emailResentContainer;
